import SongContainer from 'components/Song/SongContainer'
import SongData from 'components/Song/SongData'
import SongPresentation from 'components/Song/SongPresentation'
import SongPresentationDrawer from 'components/Song/SongPresentationDrawer'

export default {
  Container: SongContainer,
  Data: SongData,
  Presentation: SongPresentation,
  PresentationDrawer: SongPresentationDrawer,
}
